var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bio-material-type-select-wrapper"
  }, [_c('VHeader', {
    attrs: {
      "modal-button": true
    },
    on: {
      "close-modal": _vm.emitClose
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_vm._v("Choose Material Type to Add")];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('SingleSelectFilter', {
    attrs: {
      "id": "bio-material-type-select",
      "label": "Type",
      "multiple": false,
      "get-value": _vm.bioMaterialBundles,
      "track-by": "id",
      "text-field": "label",
      "display-value": "Type"
    },
    on: {
      "update-filter": _vm.updateSelectedType
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "choose-material-action"
  }, [_c('VButton', {
    class: _vm.selectedType ? 'primary' : 'disabled',
    attrs: {
      "id": "bio-material-type-choose",
      "disabled": !_vm.selectedType
    },
    on: {
      "click": _vm.emitSelectedType
    }
  }, [_vm._v("\n      Next\n    ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }